export function CATEGORY_REQUEST(state) {
  state;
  state.categories = {
    ...state.categories,
    isLoading: true
  };
}
export function CATEGORY_SUCCESS(state, payload) {
  const data = [];
  payload.data.data.categories.rows.map(item => {
    data.push({
      id: item.kategoriId ? item.kategoriId : "-",
      categoryName: item.description ? item.description : "-",
      kategoriCode: item.kategoriCode ? item.kategoriCode : "-",
      categoryParent: item.parentId ? item.parentId : "-",
      description: item.description ? item.description : "-",
      thumbnail: item.thumbnail ? item.thumbnail : "-",
      is_active: item.isActive ? item.isActive : false
    });
    return item;
  });

  state;
  state.categories = {
    ...state.categories,
    data: data,
    count: payload.data.data.categories.count,
    status: payload.status,
    isLoading: false
  };
}
export function CATEGORY_ERROR(state, payload) {
  state;
  state.isLoading = false;
  state.error = true;
  state.errorMessage = payload;
}

export function GET_CATEGORY_REQUEST(state) {
  state;
  state.category = {
    ...state.category,
    isLoading: true
  };
}
export function GET_CATEGORY_SUCCESS(state, payload) {
  state;
  state.category = {
    isLoading: false,
    data: payload.data.kategori.row,
    status: payload.status
  };
}
export function GET_CATEGORY_ERROR(state, payload) {
  state;
  state.category = {
    isLoading: false,
    error: true,
    errorMessage: payload
  };
}

export function CREATE_CATEGORY_REQUEST(state) {
  state;
  state.category = {
    ...state.category,
    isLoading: true
  };
}
export function CREATE_CATEGORY_SUCCESS(state, payload) {
  state;
  state.categories = {
    ...state.categories,
    data: state.categories.data.map(item => {
      if (item.id === payload.kategoriId) {
        return Object.assign({}, item, payload);
      }
      return item;
    }),
    isLoading: false,
    status: 200
  };
}
export function CREATE_CATEGORY_ERROR(state, payload) {
  state;
  state.isLoading = false;
  state.error = true;
  state.errorMessage = payload;
}

export function EDIT_CATEGORY_REQUEST(state) {
  state;
  state.category = {
    ...state.category,
    isLoading: true
  };
}
export function EDIT_CATEGORY_SUCCESS(state, payload) {
  state;
  state.categories = {
    ...state.categories,
    data: state.categories.data.map(item => {
      if (item.id === payload.kategoriId) {
        return Object.assign({}, item, payload);
      }
      return item;
    }),
    isLoading: false,
    status: 200
  };
}
export function EDIT_CATEGORY_ERROR(state, payload) {
  state;
  state.isLoading = false;
  state.error = true;
  state.errorMessage = payload;
}

export function DELETE_CATEGORY_REQUEST(state) {
  state;
  state.isLoading = true;
}
export function DELETE_CATEGORY_SUCCESS(state, payload) {
  let index = state.categories.findIndex(item => item.id == payload.id);
  state.categories.splice(index, 1);
  state;
  state.categories;
  state.isLoading = false;
}
export function DELETE_CATEGORY_ERROR(state, payload) {
  state;
  state.isLoading = false;
  state.error = true;
  state.errorMessage = payload;
}
